import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import Header from "./Header";
import Footer from "./Footer";
import { Link } from "react-router-dom";
import { Card } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation } from "swiper/modules";
import "react-medium-image-zoom/dist/styles.css";
import "swiper/css";
import "swiper/css/free-mode";

export default function Index() {
  let server_url = localStorage.getItem("server_url");

  const [data, setData] = useState([]);
  const [series, setSeries] = useState([]);

  useEffect(() => {
    get_banner();
    getSerices();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getSerices = async () => {
    try {
      const formData = new FormData();
      formData.append("company_id", "2");
      const res = await axios.post(`${server_url}series_list.php`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      if (res.data.status === "1") {
        setSeries(res.data.result);
      } else {
        setSeries([]);
      }
    } catch (e) {
      toast("Please Try After Some Time.");
    }
  };

  const get_banner = async () => {
    try {
      const formData = new FormData();
      formData.append("company_id", "2");
      const res = await axios.post(`${server_url}banners.php`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      if (res.data.status === "1") {
        setData(res.data.result);
      } else {
        // toast.warning(res.data.error);
      }
    } catch (e) {
      toast("Please Try After Some Time.");
    }
  };
  return (
    <React.Fragment>
      <Header />
      <div className="page-content">
        <div
          className="container justify-content-center"
          style={{ marginTop: "90px", marginBottom: "15px", height: "360px" }}
        >
          <Swiper
            centeredSlides={true}
            autoplay={{ delay: 3000, disableOnInteraction: false }}
            modules={[Autoplay, Pagination, Navigation]}
            className="mySwiper"
            loop={true}
            slidesPerView={1}
            spaceBetween={30}
            pagination={{ clickable: true }}
          >
            {data.map((data) => (
              <SwiperSlide key={data.offetr_id}>
                <Card className="p-0 overflow-hidden ">
                  {/* shadow */}
                  <div className="overflow-hidden rounded p-0 bg-light mobbannerall">
                    <Card.Img
                      style={{ height: "360px", objectFit: "cover" }}
                      className="mobbanner "
                      variant="top"
                      src={data.banner_image}
                    />
                  </div>
                </Card>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>

        <div className="page-content">
          <div className="row mb-0" style={{ padding: "0px 10px" }}>
            {series.map((seriess, index) => (
              <Link
                to={{
                  pathname: "/Size/" + seriess.series_id,
                  state: { stateParam: true },
                }}
                key={index}
                className="col-6 pe-0"
                style={{ padding: "0px", marginTop: "10px" }}
              >
                <div
                  className="card card-style"
                  style={{
                    margin: '0px 10px 0px 10px',
                    display: "flex",
                    flexDirection: "column",
                    height: "100%",
                  }}
                >
                  <div className="p-2">
                    <h4
                      className="mb-0"
                      style={{ lineHeight: "50px", fontSize: "30px" }}
                    >
                      <center>{seriess.series_name}</center>
                    </h4>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>

        <Footer />
      </div>
    </React.Fragment>
  );
}
